module.exports = __webpack_public_path__ + "img/advant5.31073e0a.png";